import UiTraining from "./UiTraining";
export default UiTraining;
